<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	import * as echarts from 'echarts';
	import JsPDF from 'jspdf'
	import html2Canvas from 'html2canvas'
	import RiskControlReport from './RiskControlReport/index.vue'
	import config from '../../../../../configHttp.js'
	import RiskReport from '../../mapsUtil/RiskReport/index.vue';
	import {
		reportingpage,
		reportinggetOne,
		getAllCompanys,
		reportinggenerate,
		delReporting
	} from "../../../../api/ReportEditor.js"
	import {
		Loading
	} from 'element-ui'
	export default {
		components: {
			RiskControlReport,
			RiskReport
		},
		data() {
			return {
				headData: getdata().headData,
				tableData: [],
				pagination: getdata().pagination,
				tablekey: 0,
				MuLuData: [{
					name: '风险总体概括',
					hang: "I"
				}, {
					name: '专项检查报告',
					hang: "II",
					XiaoMuluData: [{
						name: "税负率指标",
						Yem: "04"
					}, {
						name: "销售指标",
						Yem: "06"
					}, {
						name: "存货指标",
						Yem: "07"
					}, {
						name: "预收账款指标",
						Yem: "08"
					}, {
						name: "期间费用指标",
						Yem: "10"
					}, {
						name: "其他",
						Yem: "11"
					}, {
						name: "灰名单管理",
						Yem: "15"
					}, ]
				}],
				FxzcGk: [],
				reportings:[],
				bianji: true,
				DaqntTa: {},
				result: [],
				measures: ["ReportRisk.companyCode1"],
				headDatabottom: getdata().headDatabottom,
				tableDatabottom: [],
				showVersion: false,
				isYl: false,
				riskIndex: [],
			}
		},
		created() {
			this.reportingpage()
		},
		mounted() {},
		methods: {
			//删除
			deteteShanc(e) {
				let ids = []
				if (e == "") {
					if (this.$emptyandnull(this.$refs.tablebox.getSelectionval().length)) {
						this.$message.error('请选择要删除的数据');
						return false;
					}
					ids = this.$refs.tablebox.getSelectionval().map(v => v.id)
				} else {
					ids[0] = e
				}
				this.$showConfirm({
					message: '是否删除当前选择的数据?',
					title: '删除'
				}).then(res => {
					if (res == 'confirm') {
						delReporting(ids).then(res => {
							if (res.data.code == 1) {
								this.$message.success('删除成功');
								this.reportingpage()
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			},
			dowPdf(e) {
				let params = {
					downUrl: config.baseURL + '/reporting/downloadPdf',
					typeObj: {
						toForm: true,
						fileType: 'zip',
						failUrl: this.$winURl,
						headers: {
							Authorization: localStorage.getItem('nstoken')
						}
					},
					params: {
					}
				};
				this.$downloadcommon(params);
			},
			Daochua(e) {
				let params = {
					id: e
				}
				reportinggetOne(params).then(res => {
					if (res.data.code == 1) {
						if (res.data.data.riskLevel == null || res.data.data.riskLevel == "" || res.data.data
							.riskLevel == undefined) {
							res.data.data.riskLevel = "低"
						}
						this.DaqntTa = res.data.data;
						
						// this.measures = [this.DaqntTa.companyCode]
						//本次模型命中情况
						this.result = [];
						// 遍历所有 modeType 类型
						const modeTypes = [...new Set(this.DaqntTa.smwds.map(item => item.modeType))];
						modeTypes.forEach(modeType => {
							// 筛选 modeType 相同的数据
							const modeTypeData = this.DaqntTa.smwds.filter(item => item.modeType ===
								modeType);
							// 将 modeType 的名称和数据添加到结果数组中
							this.result.push({
								modeType,
								data: modeTypeData
							});
						});
						//目录
						this.MuLuData[1].XiaoMuluData = [];
						let shu = 4;
						const smwds = [...new Set(this.DaqntTa.reportings.map(item => item.smwd))];
						let zhansc = 0;
						this.reportings = []
						smwds.forEach((smwd, index) => {
							// 筛选 modeType 相同的数据
							const smwdsData = this.DaqntTa.reportings.filter(item => item.smwd === smwd);
							this.reportings = [...this.reportings, ...smwdsData]
							if (index == 0) {
								shu += 1
								zhansc = smwdsData.length;
							} else {
								shu += zhansc;
								zhansc = smwdsData.length;
							}
							this.MuLuData[1].XiaoMuluData.push({
								name: smwd,
								Yem: shu < 10 ? "0" + shu : shu
							});
						});
						//图表分析
						this.riskIndex = []
						this.reportings.map(v => {
							this.riskIndex.push([v.riskIndexCode])
						})
						//风险总体概况
						this.FxzcGk = [];
						for (let var1 in this.DaqntTa.categoryMap) {
							this.FxzcGk.push({
								name: var1,
								Suoming: this.DaqntTa.categoryMap[var1]
							})
						}


						var loading = Loading.service({
							lock: true,
							text: 'PDF导出中，请稍等',
							background: 'rgba(0, 0, 0, 0.7)'
						})
						let Iddui = 4 + this.DaqntTa.reportings.length;
						let Idlist = [];
						for (let i = 0; i < Iddui; i++) {
							Idlist.push(i)
						}
						setTimeout(() => {
							this.$nextTick(() => {
								this.htmlToPdf(Idlist.join(','), this
									.DaqntTa.companyName + '的风险报告')
							})
						}, 3500)
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			forback(e) {
				this.DaqntTa = {};
				this.bianji = e;
				this.reportingpage()
			},
			//编辑
			Bianju(e, isYl) {
				let params = {
					id: e
				}
				reportinggetOne(params).then(res => {
					if (res.data.code == 1) {
						this.isYl = isYl;
						if (res.data.data.riskLevel == null || res.data.data.riskLevel == "" || res.data.data
							.riskLevel == undefined) {
							res.data.data.riskLevel = "低"
						}
						this.DaqntTa = res.data.data
						this.bianji = false
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			reportingpage() {
				let params = {}
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				reportingpage(params).then(res => {
					if (res.data.code == 1) {
						this.tableData = res.data.data.records
						this.pagination.total = res.data.data.total;
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			kangq() {
				this.$nextTick(() => {
					this.htmlToPdf('0,1,2,3,4', 'pdf生成')
				})
			},

			//表格字段排序
			sortchange(e) {
				console.log(e)
			},
			//显示条数
			sizechange(e) {
				this.pagination.pageSize = e;
			},
			//显示页码
			currentChange(e) {
				this.pagination.pageNum = e;
			},

			//弹框
			shengcbb() {
				getAllCompanys().then(res => {
					if (res.data.code == 1) {
						this.tableDatabottom = res.data.data
						this.showVersion = true;
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			//生成报表
			shengcheng() {
				if (this.$refs.tableboxsc.getSelectionval().length == 0) {
					this.$message.error("请选择需要生成报告的公司!")
					return
				}
				reportinggenerate(this.$refs.tableboxsc.getSelectionval().map(v => v.id)).then(res => {
					if (res.data.code == 1) {
						this.showVersion = false;
						this.reportingpage()
					} else {
						this.$message.error(res.data.msg)
					}
				})

			}
		}
	};
</script>

<style scoped lang="less">
	@import url('index.less');
</style>